import { combineReducers } from '@reduxjs/toolkit';

import { api } from '../services/api';

import auth from './feature/Auth';
import provider from './feature/Provider';
import script from './feature/Script';
import resource from './feature/Resource';
import contracts from './feature/Contracts';
import cloudProvisionerTemplate from './feature/CloudProvisionerTemplate';


const reducers = combineReducers({
  auth,
  script,
  contracts,
  provider,
  resource,
  cloudProvisionerTemplate,
  [api.reducerPath]: api.reducer,
});

export default reducers;
